module.exports = __webpack_public_path__ + "img/Station Plans_01.54a63099.jpg";